import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import { ReoccurrenceSettings } from "components/settings";
import { FormRadio } from "components/form-fields";

export function EmployeeAssessmentBandSettings(
    {
        disabled = false,
        loading = false,
        alertTypes,
        bandSettings,
        onBandSettingsUpdate,
        onValidationUpdate
    }
) {
    function onReoccurrenceChange(item) {
        const updatedBandSettings = {
            ...bandSettings,
            reoccurrenceSchedule: item
        }

        onBandSettingsUpdate(updatedBandSettings);
    }

    function onAlertTypeChange(item) {
        const updatedBandSettings = {
            ...bandSettings,
            alertType: item.target.value
        }

        onBandSettingsUpdate(updatedBandSettings);
    }

    return (
        <Fragment>
            <ReoccurrenceSettings
                loading={loading}
                reoccurrenceSettings={bandSettings.reoccurrenceSchedule}
                onReoccurrenceUpdate={onReoccurrenceChange}
                hideEndDates={true}
                hide445={true}
                onValidationUpdate={onValidationUpdate}
                name="employee assessments"
                disabled={disabled}
                reoccurrenceToggleText="Would you like your employee assessments to generate automatically?"
                reoccurrenceFrequencyHelperText="When an employee assessment is completed, the next assessment will be generated using the interval given below."
            ></ReoccurrenceSettings>
            <FormRadio
                selectedValue={bandSettings.alertType}
                loading={loading}
                options={alertTypes}
                onChange={onAlertTypeChange}
                disabled={disabled}
                headingText="How would you like to send alerts for your employee assessments?"
                helperText="Notification alerts will be generated in Vision and these can be confirmed once reviewed by a relevant Vision user. Sign Off alerts will be generated in Vision and can only be removed once sign off is completed by a Vision user with the relevant action."
            />
        </Fragment>
    );
}

EmployeeAssessmentBandSettings.propTypes = {
    bandSettings: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onBandSettingsUpdate: PropTypes.func.isRequired,
    onValidationUpdate: PropTypes.func.isRequired,
    alertTypes: PropTypes.array.isRequired
};